import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum DeviceType {
  Desktop = 'desktop',
  Smartphone = 'smartphone',
  Tablet = 'tablet',
  Console = 'console',
  PortableMediaPlayer = 'portable media player',
  TV = 'tv',
  CarBrowser = 'car browser',
  Camera = 'camera',
}

export interface DeviceFingerprintComponentAttributes {
  'visiter-id'?: string;
  incognito?: boolean;
  'browser-name'?: string;
  'browser-version'?: string;
  ip?: string;
  'ip-location'?: {
    latitude?: number;
    longitude?: number;
    'postal-code'?: string;
    timezone?: string;
    city?: {
      name?: string;
    };
    country?: {
      code?: string;
      name?: string;
    };
    continent?: {
      code?: string;
      name?: string;
    };
    subdivisions?: {
      'iso-code'?: string;
      name?: string;
    };
  };
  'first-seen-at'?: {
    global: string;
    subscription: string;
  };
  'last-seen-at'?: {
    global: string;
    subscription: string;
  };
  os?: string;
  'os-version'?: string;
}

export interface DeviceAttributes {
  'user-agent'?: string | null;
  'os-name'?: string | null;
  'os-full-version'?: string | null;
  'device-type'?: DeviceType | null;
  'device-name'?: string | null;
  'browser-name'?: string | null;
  'browser-full-version'?: string | null;
  'mobile-sdk-name'?: string | null;
  'mobile-sdk-full-version'?: string | null;
  'browser-fingerprint'?: string | null;
  'device-fingerprint'?: string | null;
  'device-fingerprint-components'?: DeviceFingerprintComponentAttributes | null;
  'device-vendor-id'?: string | null;
}

export interface DeviceRelationships {}

export type Device = ApiResource<DeviceAttributes, DeviceRelationships, ApiModel.Device>;
